module.exports = __webpack_public_path__ + "static/img/9.09340bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/9.png
// module id = J9V3
// module chunks = 0